import React from 'react'

const LowerMap = () => {
    return (
        <>
            <section className="map-sec mb-3">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d58891.56454179108!2d88.35262974257351!3d22.701361439736857!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f89c0bf0119e61%3A0xf3dedf82eaf68307!2sSodepur%2C%20Kolkata%2C%20West%20Bengal!5e0!3m2!1sen!2sin!4v1650711587977!5m2!1sen!2sin" width="600" height="450" style={{border:"0"}}  loading="lazy"></iframe>
                <div className="srch-bx">
                    {/* <form method="get" action="#">
                        <input type="text" placeholder="Search your Location" />
                        <button type="submit" className="search-icon">
                            Search
                        </button>
                    </form> */}
                </div>
            </section>

        </>
    )
}

export default LowerMap